import { LeftOutlined } from '@ant-design/icons';
import Screen from 'components/BusinessLogic/ScreenTemplates/LoggedScreen';
import Breadcrumb from 'components/UI/Breadcrumb';
import { MyOrderIntentionsContextProvider } from 'contexts/MyOrderIntentionsContext';
import {
  isCardsLayout,
  useResponsiveLayout,
} from 'hooks/layout/useResponsiveLayout';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { sessionSelectors } from 'store/state/selectors';
import TabVol from './Tab';
import {
  ContinueShoppingButton,
  Divider,
  Header,
  HeaderLine1,
  HeaderLine1GroupLeft,
  HeaderLine2,
  Legend,
  Root,
  Title,
  TypeProductsContainer,
} from './styles';

export default function MyOrderIntentions() {
  const customerId = useSelector(sessionSelectors.getSelectedCustomerId);
  const producerUrl = useSelector(sessionSelectors.getProducerUrl);

  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const showsCards = isCardsLayout(useResponsiveLayout());

  return (
    <MyOrderIntentionsContextProvider>
      <Screen
        content={
          <Root>
            <Divider />

            {!showsCards && (
              <Header>
                <HeaderLine1>
                  <HeaderLine1GroupLeft>
                    <Title>{translate('myOrderIntentions.title')}</Title>
                    <Legend>{translate('myOrderIntentions.legend')}</Legend>
                  </HeaderLine1GroupLeft>
                  <Breadcrumb
                    levels={[{ description: translate('breadcrumb.myOrderIntentions') }]}
                  />
                </HeaderLine1>
                <HeaderLine2>
                  <ContinueShoppingButton
                    icon={<LeftOutlined />}
                    onClick={() => navigate(`/${producerUrl}/products`)}
                  >
                    {translate('shoppingCart.continueShopping')}{' '}
                  </ContinueShoppingButton>
                </HeaderLine2>
              </Header>
            )}

            <TypeProductsContainer>
              <TabVol customerId={customerId} />
            </TypeProductsContainer>
          </Root>
        }
      />
    </MyOrderIntentionsContextProvider>
  );
}
